import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import Plot from "../pages/plot/page";
import Reviews from "../pages/reviews/page";
import ReviewDetail from "../pages/review-detail/page";
import News from "../pages/news/page";
import NewsDetail from "../pages/news-detail/page";
import About from "../pages/about/page";
import Search from "../pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "plot", element: <Plot /> },
      { path: "reviews", element: <Reviews /> },
      { path: "review/:id", element: <ReviewDetail /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "about", element: <About /> },
      { path: "search", element: <Search /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;